import React, {Component} from "react"
import styled from "styled-components"

import authentication from "@irati/auth"
import {TextButton} from "@irati/ui/src/Button"
import {Poll, Recognition} from "@irati/types"

import {CommentsIcon, ReactionsIcon, AddRewardIcon} from "./"
import {ReactionList} from "../Reactions"

const Container = styled.div`
  display: flex;

  ${TextButton} {
    margin-right: 6px;
  }
`
interface Props {
  item: Poll|Recognition,
  type: string,
  onClickComment: () => void,
  togglePickerModal: () => void,
  feedItemId?: string
}

class Activity extends Component<Props> {
  static defaultProps = {
    onClickComment: () => {},
    togglePickerModal: () => {},
    feedItemId: "feedItemId"
  }

  render() {
    const {item, type, onClickComment, togglePickerModal, feedItemId} = this.props
    const areReactionsEnabled = !!authentication.apps("recognition.recognition.reactions")

    return (
      <Container>
        <div>
          <AddRewardIcon item={item} type={type} />
          <CommentsIcon id={feedItemId} item={item} onClick={onClickComment} />
          {areReactionsEnabled && <ReactionList item={item} />}
          {areReactionsEnabled && <ReactionsIcon onClick={togglePickerModal} />}
        </div>
      </Container>
    )
  }
}

export default Activity
